var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mc-rich-text-editor',{ref:"richTextEditorRef",staticStyle:{"min-height":"300px","max-width":"99%"},attrs:{"value":_vm.innerValue,"upload-config":{
            maxFileSize: 5
        },"menubar":_vm.menubar,"readonly":_vm.disabled},on:{"change":_vm.handleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }